/** Shared responsive layout for dashboard widget title + filter rows.
 * Title left, filters right. Filters wrap under the title on narrow cards
 * and stay right-aligned (Weekly Expenses pattern when they fit on one row).
 */
export const dashboardWidgetHeaderSx = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  columnGap: { xs: 0.75, md: 1 },
  rowGap: { xs: 0.5, md: 0.75 },
  width: "100%",
} as const;

/** Title / icon cluster — left side of the header */
export const dashboardWidgetTitleRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  minWidth: 0,
  flex: "0 1 auto",
  maxWidth: "100%",
  textAlign: "left" as const,
  justifyContent: "flex-start",
} as const;

export const dashboardWidgetTitleSx = {
  fontSize: { xs: 12, sm: 13, md: 14 },
  fontWeight: { xs: 600, md: 700 },
  color: "#212B36",
  lineHeight: 1.3,
  textAlign: "left" as const,
};

export const dashboardWidgetFiltersSx = {
  display: "flex",
  flexWrap: "nowrap" as const,
  alignItems: "center",
  gap: 0.5,
  flexShrink: 0,
  flex: "0 0 auto",
  maxWidth: "100%",
  marginLeft: "auto",
  justifyContent: "flex-end",
  alignSelf: "center",
};

/** Shared height for chart widgets that sit in the same visual row */
export const DASHBOARD_CHART_WIDGET_HEIGHT = 380;

/** Shared height for compact row widgets (Target vs Sales / WIP / Job Cards) */
export const DASHBOARD_COMPACT_WIDGET_HEIGHT = 230;

/** Shared height for mid row widgets (Payments / Bay / Customer Breakdown) */
export const DASHBOARD_MID_WIDGET_HEIGHT = 240;

/** Shared height for list row widgets (Top Services / Make Model / Avg Time) */
export const DASHBOARD_LIST_WIDGET_HEIGHT = 300;

/** Hide widget header icons on small / cramped layouts */
export const dashboardWidgetIconSx = {
  display: { xs: "none", xl: "flex" },
} as const;
